import { IGetFornecedorByIdUseCase } from "../../../presentation/useCases/read/get_fornecedor_by_id_use_case";
import { FornecedorDetalhe } from "../../models/fornecedor_detalhe";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFornecedorByIdUseCase
 */

export class GetFornecedorByIdUseCase implements IGetFornecedorByIdUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFornecedorById(
    idFornecedor: number | undefined | null,
  ): Promise<FornecedorDetalhe> {
    if (idFornecedor === null) throw new Error('Falha ao obter id do fornecedor!');
    if (idFornecedor === undefined) throw new Error('Falha ao obter id do fornecedor!');
    const response = await this.repository.getFornecedorById(idFornecedor);
    if (response === null) throw new Error('Falha ao obter fornecedor!');
    return response;
  }
}
